import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createPartnerAsync, deletePartnerAsync, getAllPartnersAsync, getAllPartnersByCompanyAsync, getPartnerByIdAsync, updatePartnerAsync, getSuggestedPeopleForPartnerAsync } from './partnerThunk';
const initialState = {
    status: APIStatus.IDLE,
    partners: null,
    partner: undefined,
    suggestedPeople: null,
    currentPartnerId: null
};
export const partnerSlice = createSlice({
    name: 'partner',
    initialState,
    reducers: {
        resetSuggestedPeopleApiState(state) {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        },
        clearSuggestedPeople(state) {
            state.suggestedPeople = null;
            state.currentPartnerId = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createPartnerAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createPartnerAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.partner = action.payload.data;
        })
            .addCase(createPartnerAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updatePartnerAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updatePartnerAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.partner = action.payload;
        })
            .addCase(updatePartnerAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllPartnersAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPartnersAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.partners = action.payload;
        })
            .addCase(getAllPartnersAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPartnerByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPartnerByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.partner = action.payload;
        })
            .addCase(getPartnerByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deletePartnerAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deletePartnerAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deletePartnerAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllPartnersByCompanyAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPartnersByCompanyAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.partners = {
                items: action.payload,
                pageNumber: 1,
                pageSize: action.payload?.length ?? 0,
                totalCount: action.payload?.length ?? 0,
                totalPages: 1
            };
        })
            .addCase(getAllPartnersByCompanyAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getSuggestedPeopleForPartnerAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getSuggestedPeopleForPartnerAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            const payload = action.payload;
            const request = action.meta.arg;
            // If skip > 0, append to existing items; otherwise replace
            if (request.skip && request.skip > 0 && state.suggestedPeople) {
                // Append new items, avoiding duplicates
                const existingIds = new Set(state.suggestedPeople.items.map(item => item.personId));
                const newItems = payload.items.filter(item => !existingIds.has(item.personId));
                state.suggestedPeople = {
                    ...payload,
                    items: [...state.suggestedPeople.items, ...newItems]
                };
            }
            else {
                // First page or skip = 0 - replace all
                state.suggestedPeople = payload;
            }
            state.currentPartnerId = request.partnerId;
        })
            .addCase(getSuggestedPeopleForPartnerAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
    }
});
export const { resetSuggestedPeopleApiState, clearSuggestedPeople } = partnerSlice.actions;
export default partnerSlice.reducer;
